module.exports = __webpack_public_path__ + "img/casting.e3d2aec8.jpg";